import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import "./index.css";
import Layout from "./Layout/Layout";
import { ToastContainer } from "react-toastify";
import User from "./pages/User";
import MeetingRequest from "./pages/MeetingRequest";
import { userID, userRole } from "./utils/storage";
import ErrorPage from "./Components/error/ErrorPage";
import PrivateRoute from "./PrivateRoute";
import MyProfile from "./Components/propfile/MyProfile";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import EventList from "./pages/EventList";
import TaskList from "./pages/TaskList";
import Setup from "./pages/Setup";
import MeetingTitle from "./pages/MeetingTitle";
import ChairmanMeeting from "./Components/ChairmanMeeting/Chairmanmeeting";

const queryClient = new QueryClient();

const App = () => {
  return (
    <Router>
      <ToastContainer />
      <QueryClientProvider client={queryClient}>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={userID ? <Navigate to="/home" replace /> : <Login />}
          />
          <Route
            path="/login"
            element={userID ? <Navigate to="/home" replace /> : <Login />}
          />

          {/* Protected Routes */}
          <Route
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route path="/home" element={<Dashboard />} />
            <Route path="/users" element={<User />} />
            <Route path="/meeting-request" element={<MeetingRequest />} />
            <Route
              path="/chairman-meeting-request"
              element={userRole === "SUPER_ADMIN" ? <ChairmanMeeting /> : <Navigate to="/home" replace />}
            />
            <Route path="/events" element={<EventList />} />
            <Route
              path="/tasks"
              element={userRole === "SUPER_ADMIN" ? <TaskList /> : <Navigate to="/home" replace />}
            />
            <Route path="/setup" element={<Setup />} />
            <Route path="/setup/meeting-heading" element={<MeetingTitle />} />
            <Route path="/myprofile" element={<MyProfile />} />

          </Route>

          {/* Catch-all for 404 */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </QueryClientProvider>
    </Router>
  );
};

export default App;
